import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../../../utils/hooks/useMutationWithError";
import {
  UserContactStatus,
  useCheckUserPhoneStatusProfileMutation,
} from "./__generated__/useCheckUserPhoneStatusProfileMutation.graphql";

export const useCheckUserPhoneStatusProfile = () => {
  const [checkStatus, isChecking] =
    useMutationWithError<useCheckUserPhoneStatusProfileMutation>(
      userCheckPhoneProfileMutationString
    );

  const { showToast } = useToast();

  const onCompletedErrorCustom = (errors: any) => {
    showToast({
      description: t`Whoops. Looks like you inserted an invalid phone number. Please try again.`,
      semanticStyle: "error",
      toastId: "loginError",
    });
    return [];
  };

  const checkPhone = (
    phoneNumber: string,
    onCompleteHandler: (
      value: string,
      result: UserContactStatus,
      type: "Phone"
    ) => void
  ) => {
    checkStatus({
      variables: { input: { phoneNumber } },
      onCompleted: (res) => {
        if (res.responsePayload?.success && res.responsePayload.result) {
          onCompleteHandler(phoneNumber, res.responsePayload.result, "Phone");
        }
      },
      onCompletedErrorCustom: (errors) => onCompletedErrorCustom(errors),
    });
  };
  return [checkPhone, isChecking] as const;
};

export const userCheckPhoneProfileMutationString = graphql`
  mutation useCheckUserPhoneStatusProfileMutation(
    $input: UserPhoneStatusInput!
  ) {
    responsePayload: userPhoneStatus(input: $input) {
      success
      result
      errors {
        field
        code
        message
      }
    }
  }
`;
